module.exports = __webpack_public_path__ + "img/allianz.589288a0.png";